/*! Michael Pumo - app.js */

import { domReady } from "./utilities/helpers";
import framework from "./framework";

function start() {
  framework();
}

domReady(start);
